import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { Link } from "react-router-dom";
import { FETCH_STOCK_CATEGORIES } from "./graphql";

const SalesInventoryIndexPage = () => {
  const { loading, error, data } = useQuery(FETCH_STOCK_CATEGORIES, {
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  // Sort by name
  const stockCategories = [...data.stockCategories].sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  return (
    <Page title="Sales Inventory">
      <div className="p-6 grid grid-cols-3 gap-6">
        {stockCategories.map((category) => (
          <div key={category.id} className="card">
            <Link to={`${category.id}`}>
              <h5>{category.name}</h5>
            </Link>
            <div className="mt-2 whitespace-pre-wrap">{category.notes}</div>
          </div>
        ))}
      </div>
    </Page>
  );
};

export default SalesInventoryIndexPage;
